<template>   
     <v-breadcrumbs :items="bcItems" divider="-"><div v-if="getBcChange">{{readItems()}}</div></v-breadcrumbs>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      bcItems: [{  text: 'Dashboard', disabled: false, href: '/#/dashboard' }]
    }
  },
  computed: 
    mapGetters([
                'getBcChange'
            ])
  ,
  methods: {
    readItems() {
      this.$store.commit('setBcChange',false)
      this.bcItems = JSON.parse(localStorage.getItem('bc'))    
    }
  }
}
</script>

<style>

</style>